import type { ProductCardProps } from "@/components/product";
import { ProductCard } from "@/components/product";
import { Divider } from "@/ui";

export const PreviousCareplanProduct = ({ product, ref }: ProductCardProps) => {
  return (
    <ProductCard.Root
      aria-label={product.name}
      className="relative flex scroll-mt-20 flex-col gap-6 px-5 py-6 focus:outline-3 focus:outline-offset-2 focus:outline-focus focus:outline-solid sm:scroll-mt-22 sm:gap-8 sm:px-10 sm:py-10"
      key={product.id}
      product={product}
      ref={ref}
    >
      <div aria-hidden="true" className="absolute inset-0 rounded-card bg-surface/60" />
      <div className="flex flex-col gap-6 sm:gap-8">
        <div className="flex flex-col gap-2">
          <div className="flex flex-col items-start sm:flex-row sm:items-center">
            {!!product.whyRecommended && (
              <ProductCard.WhyRecommended className="sm:mr-auto sm:ml-0" />
            )}
            <ProductCard.UpdatedAt className="relative sm:mr-0 sm:ml-auto" />
          </div>
          <Divider.Line />
        </div>
      </div>
      <div className="grid gap-6 md:grid-cols-2">
        <ProductCard.Image className="sm:w-full" />
        <div className="flex flex-col gap-2">
          <ProductCard.Name level={2} />
          <ProductCard.Price />
          <ProductCard.Description />
        </div>
      </div>
    </ProductCard.Root>
  );
};
